import type { AssessmentCohort } from 'hooks/analytics';

export const assessmentCompletionColors = {
    combined: '#2563EB',
    selfAssessment: '#059669',
    agentAssisted: '#7C3AED',
    withCv: '#0284C7',
    withoutCv: '#475569',
    mixed: '#D97706',
} satisfies Record<AssessmentCohort | 'mixed', string>;

export default assessmentCompletionColors;
